export default {
  ordersFor: '{day} Užsakymai',
  name: 'Vardas',
  soup: 'Sriuba',
  mainDish: 'Pagrindinis Patiekalas',
  price: 'Kaina',
  viewUsersWithoutRequests: 'Peržiūrėti vartotojus be užsakymo',
  usersWithoutOrder: 'Vartotojai Be Užsakymo',

};
